import { render } from "./EqRecordConfigZhiZaoAdd.vue?vue&type=template&id=96f8f454&scoped=true"
import script from "./EqRecordConfigZhiZaoAdd.vue?vue&type=script&lang=js"
export * from "./EqRecordConfigZhiZaoAdd.vue?vue&type=script&lang=js"

import "./EqRecordConfigZhiZaoAdd.vue?vue&type=style&index=0&id=96f8f454&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f8f454"]])

export default __exports__